module.exports = __webpack_public_path__ + "img/12.d922cd11.png";